import axios from "../../config/axiosConfig";
import {
  CREATE_SALES_ORDER,
  DELETE_SALES_ORDER,
  GET_SALES_ORDERS,
  SALES_ORDER_REQUEST,
  SALES_ORDER_REQUEST_SUCCESS,
  SALES_ORDER_REQUEST_FAILURE,
  UPDATE_SALES_ORDER,
  GET_SALES_ORDERS_PAGE
} from "../types";
import { getStates } from "./state-actions";

export const getSalesOrderWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_ORDER_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Delivery_Account_Id,Purchase_Account_Id,Lot_Id'
      };
      return axios.get("/sales-order/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALES_ORDERS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSalesOrders = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_ORDER_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/sales-order/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALES_ORDERS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getSalesOrdersByRange = (bookId, billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/sales-order/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getSalesOrderById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_ORDER_REQUEST });
      return axios.get(`/sales-order/get/${id}`).then((response) => {
        dispatch({ type: SALES_ORDER_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
export const createSalesOrder = (salesOrder) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: SALES_ORDER_REQUEST });
      const newSalesOrder = {
        ...salesOrder
      };
      return axios.post("/sales-order/add", newSalesOrder,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SALES_ORDER, payload: response.data });
        } else {
          dispatch({
            type: SALES_ORDER_REQUEST_FAILURE,
            error: "Sales Order create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateSalesOrder = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_ORDER_REQUEST });
      const { auth } = getState();
      return axios.put("/sales-order/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SALES_ORDER,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: SALES_ORDER_REQUEST_FAILURE,
            error: "Sales Order update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteSalesOrder = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_ORDER_REQUEST });
      return axios.delete(`/sales-order/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SALES_ORDER, id: id });
        }
        const include = ['id', 'Order_No', 'Ref_Order_No', 'Book_Id', 'Date', 'Account_Id', 'Delivery_Account_Id', 'Purchase_Account_Id', 'Lot_Id', 'Net_Total'].join(',');
        const searchCols = ['Order_No'].join(',');
        const { page, pageSize, searchStr, where,  } = getState()?.inventory?.salesOrder || {};
        dispatch(getSalesOrderWithPagination(page, pageSize, include, searchStr, searchCols, where, true));
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SALES_ORDER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateSalesOrderTransaction = (id, data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      return axios.put("/sales-order-transaction/update", { id, data },
        { params: { userId: auth.user?.id } }
      ).then((response) => {
        return response;
      }).catch((error) => {
        console.error(error);
        throw error;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const sendMailSaleOrder = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_ORDER_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('salesOrderId', mailData.salesOrderId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `sales_order_${mailData.salesOrderId}.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/sales-order/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_ORDER_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_ORDER_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_ORDER_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappSaleOrder = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_ORDER_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('salesOrderId', whatsappData.salesOrderId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `sales_order_${whatsappData.salesOrderId}.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/sales-order/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_ORDER_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_ORDER_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_ORDER_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const validatePartyInSalesOrder = (partyId, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      const response = await axios.get("/sales-order/validate-party", { params: { ...params, partyId, bookId } });
      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getSalesAccountOs = (partyId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();

      const params = {};
      if (!auth?.company?.Common_Master) {
        params.companyId = auth.company?.id;
      }

     const response = await axios.post( "/sales-order/sales-outstanding-by-account-id", { accountIds: [partyId] }, { params } );

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};